// Remembers where to send the user after they log in or sign up, e.g. back to
// /chat when they tried to chat while logged out. Kept per tab and only for a
// while, so a later unrelated login still lands on the usual page.
const STORAGE_KEY = "postAuthRedirect";
const MAX_AGE_MS = 30 * 60 * 1000;

export const setPostAuthRedirect = (path) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ path, at: Date.now() }));
  } catch (e) {}
};

// Returns the saved in-app path (and forgets it), or the fallback
export const takePostAuthRedirect = (fallback) => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "null");
    sessionStorage.removeItem(STORAGE_KEY);
    if (saved && typeof saved.path === "string" && saved.path.startsWith("/") &&
        !saved.path.startsWith("//") && Date.now() - saved.at < MAX_AGE_MS) {
      return saved.path;
    }
  } catch (e) {}
  return fallback;
};
